import { motion } from "framer-motion";
import ocean from "../../assets/ocean.webp";

function JoinCta({
  copy = "The SE7ENS aren't the end. They’re a reminder that what God begins, He always completes.",
}) {
  return (
    <section className="relative w-screen h-[100vh] min-h-[800px] overflow-hidden">
      <div
        className="absolute inset-x-0 top-0 h-[70%] bg-neutral-200"
        style={{
          backgroundImage: `url(${ocean})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          filter: "grayscale(100%)",
        }}
      >
        <div className="absolute inset-0 bg-black/20" />
      </div>

      <div className="absolute inset-x-0 bottom-0 h-[50%] bg-black" />

      <div className="absolute inset-0 z-10 flex flex-col justify-center text-left px-4 sm:px-8 md:px-16">
        <motion.h2
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.5 }}
          transition={{ duration: 0.8, ease: "easeOut" }}
          className="leading-[0.9] font-black text-white text-[16vw] md:text-[12vw] mt-1 md:mt-2 font-spartan"
        >
          SEE THE
          <br />
          SE7ENS
        </motion.h2>

        <motion.p
          initial={{ opacity: 0, y: 12 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: 0.15, duration: 0.6 }}
          className="absolute bottom-12 max-w-md text-sm md:text-base text-neutral-300"
        >
          {copy}
        </motion.p>
      </div>
    </section>
  );
}

export default JoinCta;
